import { defineMessages, useIntl } from 'react-intl';

import { Container } from './styles';
import Testimonial from './Testimonial';

const messages = defineMessages({
	message1: {
		id: 'book.testimonials.message1',
		defaultMessage:
			'“Great collage of ideas and practical advice of how to reduce stress in this fast paced world. A beautifully presented book which even calms you down when you pick it up. I would recommend it to everyone.”',
		description: 'A 5 star review a reader left for a book we are advertising to sell',
	},
	message2: {
		id: 'book.testimonials.message2',
		defaultMessage:
			'“A beautifully presented book that is as lovely to look at as it is to read. Simple tips and inspiration on how to bring calm into your life. Highly recommend.”',
		description: 'A 5 star review a reader left for a book we are advertising to sell',
	},
});

const Testimonials = () => {
	const { formatMessage } = useIntl();
	return (
		<Container>
			<Testimonial isLeft text={formatMessage(messages.message1)} />
			<Testimonial isLeft={false} text={formatMessage(messages.message2)} />
		</Container>
	);
};

export default Testimonials;
